/*
 * Printing-Directive
 * used in stockReport.html
 * usage: 
 * 1. mark printable-part with class="reportingContent"
 * 2. call print()
 */

angular.module('cfn').directive('cfnPrint', [
  '$rootScope',
  function($rootScope) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<iframe id="printFrame" style="width:1px;height:1px;position:fixed;top:-2px;left:-2px;border:none"></iframe>',
      controller: [
        '$scope',
        '$element',
        function($scope, $element) {
          $scope.print = function() {
            //fixedDisplaySize = 940;
            //recalcSize();

            ang.callAfter(function() {
              ang.callAfter(function() {
                $('#printFrame').attr('src', 'print.html');

                var html = $('.reportingContent').html();

                $('#printFrame').load(function() {
                  $('#printFrame')
                    .contents()
                    .find('body')
                    .html(html);
                  $('#printFrame')[0].contentWindow.focus(); // for ie we have to focus the iframe before
                  $('#printFrame')[0].contentWindow.print();
                });
                ang.callAfter(function() {
                  //fixedDisplaySize = 0;
                  //recalcSize();
                }, $scope);
              });
            }, $scope);
          };
        }
      ]
    };
  }
]);
